/* eslint-disable */
const prebidConf = {
  timeout: 900,
  floorPrices: {
    floor: 0.01,
    monday: 0.01,
    tuesday: 0.01,
    wednesday: 0.01,
    thursday: 0.01,
    friday: 0.01,
    saturday: 0.01,
    sunday: 0.01,
  },
  analytics: {
    rubicon: 12736,
  },
  useSecondaryAdSizeForPrebid: false,
  priceBuckets: {
    buckets: [
      {
        precision: 2,
        min: 0,
        max: 5,
        increment: 0.05,
      },
      {
        precision: 2,
        min: 5,
        max: 10,
        increment: 0.1,
      },
      {
        precision: 2,
        min: 10,
        max: 20,
        increment: 0.25,
      },
      {
        precision: 2,
        min: 20,
        max: 100,
        increment: 1.0,
      },
    ],
  },
  desktop_bidParams: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "129828",
        zoneId: "612414",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481061",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514105",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
  ],
  desktop_bidParams300x250: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "129828",
        zoneId: "612414",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481061",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514105",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
  ],
  bidParams_300x600: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "129828",
        zoneId: "612414",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481063",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514106",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
  ],
  bidParams_970x250: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "129828",
        zoneId: "612414",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481064",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514108",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
  ],
  bidParams_970x90: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "129828",
        zoneId: "612414",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481064",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514107",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
  ],
  bidParams_728x90: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "129828",
        zoneId: "612414",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481062",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514107",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    }
  ],
  mobile_bidParams300x250: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "87584",
        zoneId: "612410",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087280",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910941",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66063",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481061",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514117",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    }
  ],
  mobile_bidParams320x50: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "87584",
        zoneId: "612410",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087280",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910941",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66063",
      },
    },
    {
      bidder: "districtmDMX",
      params: {
        dmxid: "481065",
        memberid: "100226",
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514119",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    }
  ],
  oopBidParams: [
    {
      bidder: "unruly",
      params: {
        targetingUUID: "6f15e139-5f18-49a1-b52f-87e5e69ee65e",
        siteId: 1081534,
      },
    },
  ],
};

export default prebidConf;
